import { Component, AfterViewInit, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Equivalence } from '../../models/equivalence.model';
import { Competence } from '../../models/competence.model';
import { Groupe } from '../../models/groupe.model';
import { TableauxComponent } from '../tableaux/tableaux.component';
import $ from "jquery";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-equivalences',
  templateUrl: './equivalences.component.html',
  styleUrls: ['./equivalences.component.scss'],
})

export class EquivalencesComponent {
  @Input() equivalence: Equivalence;
  @Input() fromGroupe: Groupe;
  @Input() toGroupe: Groupe;
  @Input() first: number;
  @Input() last: number;
  @Input() isUserLoggedIn: boolean;
  @Output() equivalenceEvent = new EventEmitter<string>(); // format : id|action

  constructor(
    private tableauxComponent: TableauxComponent) {
  }

  fromComp: Competence[] = [];
  toComp: Competence[] = [];
  statut: string = "";

  ngOnInit(): void {
    this.fromComp = this.fromGroupe.competences;
    this.toComp = this.toGroupe.competences;
    if (this.equivalence.isIdentique == true)
      this.statut = "Identiques";
    else
      this.statut = "Équivalentes"
  }

  ngOnAfterViewInit(): void {

  }

  deleteEquivalence(id: number): void {
    this.equivalenceEvent.emit(id + "|DELETE");
  }

  moveEquivalence(id: number, direction: string) {
    this.equivalenceEvent.emit(id + "|" + direction);
  }

}
